import { render, staticRenderFns } from "./selaPromotionEachDate.vue?vue&type=template&id=64084b36"
import script from "./selaPromotionEachDate.vue?vue&type=script&lang=js"
export * from "./selaPromotionEachDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports